import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './theme/index.scss'
import './theme/global-styling.scss'

import { logger } from '@dw/services';
import { HttpClientError } from '@dw/models/shared';

import { App } from './App.tsx'

window.buildVersion = import.meta.env.VITE_BUILD_VERSION ?? '0.0.0';

if (window.newrelic) {
  window.newrelic.setApplicationVersion(window.buildVersion);
}

window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  event.preventDefault();
  if (!(event.reason instanceof HttpClientError)) {
    logger.error('Global Unhandled Promise Rejection Error', event);
  }
  return true;
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
